<!--suppress JSUnusedGlobalSymbols -->
<template>
  <div>
    Hello world
    <b-button v-b-tooltip.hover title="Add Watchlist"
              v-b-modal.add-calculated-field-modal>+
    </b-button>
  <add-calculated-field-dialog></add-calculated-field-dialog>
  </div>
</template>

<script>
import AddCalculatedFieldDialog from './AddCalculatedFieldDialog.vue';

export default {
  name: 'CalculatedFields',
  components: {
    AddCalculatedFieldDialog,
  },
  data() {
    return {
      calculatedFields: [],
    };
  },
  methods: {
    addCalculatedField() {

    },
    // eslint-disable-next-line no-unused-vars
    deleteField(fieldId) {
    },
  },
};
</script>
